/**
 * Error classes.
 */

/**
 * Custom error class that includes additional data.
 */
export class ErrorWithData extends Error {
  data: Record<string, unknown>;

  /**
   * Creates a new instance.
   * @param message The error message.
   * @param data Additional data associated with the error.
   */
  constructor(message: string, data: Record<string, unknown>) {
    super(message);
    this.data = data;
  }
}

/**
 * Interface representing an error response from the API.
 */
export interface ApiErrorResponse {
  data: {
    messages: { message: string }[];
  };
}

/**
 * Error thrown by REST API calls.
 */
export class ApiError extends Error {
  response: ApiErrorResponse;

  /**
   * Creates a new instance.
   * @param message The error message.
   * @param data Additional data associated with the error.
   */
  constructor(message: string, data: ApiErrorResponse['data']) {
    super(message);
    this.response = { data };
  }
}
